export default interface IAdminPageBuildingDetail {
    id: number;
    name: string;
    address: string;
    timeZone: string;
    propertyGroupName: string;
    propertyGroupId: number;
}

export const initialBuildingDetail: IAdminPageBuildingDetail = {
    id: 0,
    name: "",
    address: "",
    timeZone: "",
    propertyGroupName: "",
    propertyGroupId: 0,
};
